var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { NonVisualInfo, StepBase, StepLabel, StepList, StepNode } from './subcomponents';
const Stepper = (_a) => {
    var { steps, circleRadius = 4, onClick, className, activeStep, element, completedIcon, nonVisualInfoCompletedStep, nonVisualInfoCurrentStep, nonVisualInfoUpcomingStep } = _a, props = __rest(_a, ["steps", "circleRadius", "onClick", "className", "activeStep", "element", "completedIcon", "nonVisualInfoCompletedStep", "nonVisualInfoCurrentStep", "nonVisualInfoUpcomingStep"]);
    const getStatus = (isCompleted, isActive) => {
        if (isCompleted) {
            return nonVisualInfoCompletedStep;
        }
        if (isActive) {
            return nonVisualInfoCurrentStep;
        }
        return nonVisualInfoUpcomingStep;
    };
    return (React.createElement(StepBase, Object.assign({}, props, { className: className }), steps.map((step, index) => {
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;
        const isLastStep = activeStep === steps.length - 1;
        const status = getStatus(isCompleted, isActive);
        const stepLabel = step.label;
        return (React.createElement(StepList, { "data-testid": `step-list-${stepLabel}`, circleRadius: circleRadius, isCompleted: isCompleted, isActive: isActive, key: step.label }, element !== null && element !== void 0 ? element : (React.createElement(StepNode, { circleRadius: circleRadius, "data-testid": `step-node-${stepLabel}`, isActive: isActive, isCompleted: isCompleted, isLastStep: isLastStep, onClick: onClick &&
                ((e) => onClick(e, index)) }, (isCompleted || isLastStep) && completedIcon)),
            React.createElement(NonVisualInfo, null, status),
            React.createElement(StepLabel, { "data-testid": `step-label-${stepLabel}`, circleRadius: circleRadius, isActive: isActive }, stepLabel)));
    })));
};
export default Stepper;
